import { render } from "./DistrictTab.vue?vue&type=template&id=2e6384d2"
import script from "./DistrictTab.vue?vue&type=script&lang=js"
export * from "./DistrictTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__